"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PDFIconWrapper = exports.CancelButtonWrapper = exports.Icon = exports.OptionContent = exports.OptionHeader = exports.Description = exports.ButtonList = exports.OptionContainer = exports.Divider = exports.OptionList = exports.Header = exports.HeaderContainer = exports.Content = exports.Wrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.Wrapper = styled_components_1.default.div `
  display: ${(props) => (props.open ? "block" : "none")};
  height: 100%;
  width: 100%;
  border: 1px solid black;
`;
exports.Content = styled_components_1.default.div `
  margin: 24px;
  height: 100%;
`;
exports.HeaderContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
exports.Header = styled_components_1.default.h2 `
  font-size: 40px;
  font-weight: bold;
`;
exports.OptionList = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  padding: 24px;
  border: 1px solid ${colors_1.LIGHT_GREY};
`;
exports.Divider = styled_components_1.default.hr `
  border: 1px solid ${colors_1.LIGHT_GREY};
  width: 100%;
  margin: 16px 0;
`;
exports.OptionContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
`;
exports.ButtonList = styled_components_1.default.div `
  display: flex;
  flex-direction: row-reverse;
  margin: 23px 10px 0 1px;
`;
exports.Description = styled_components_1.default.p `
  font-size: 14px;
  font-weight: bold;
  color: ${colors_1.GREY3};
`;
exports.OptionHeader = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
exports.OptionContent = styled_components_1.default.div `
  display: ${(props) => (props.$active ? "flex" : "none")};
  flex-direction: column;
`;
exports.Icon = styled_components_1.default.img ``;
exports.CancelButtonWrapper = styled_components_1.default.div `
  margin: 0 24px;
`;
exports.PDFIconWrapper = styled_components_1.default.div `
  display: ${(props) => (props.$active ? "flex" : "none")};
`;
//# sourceMappingURL=ExportMenu.styles.js.map